<template>
  <span class="media-play-badge" aria-hidden="true">
    <img src="@/assets/img/play-icon-light.svg" alt="" class="media-play-badge__icon"/>
  </span>
</template>

<style lang="scss" scoped>
// Overlaid on a card's media (parent must be positioned), top-left — the consumed marker and
// the "Recommended" pill both sit bottom-left, so they never collide.
//
// Scheme-independent for the same reason as card-image-chip-overlay: it sits on a photo that
// does not flip with the theme, and the glyph is light, so a theme-aware fill would put a light
// glyph on a light disc in dark mode.
.media-play-badge {
  position: absolute;
  top: var(--Spacing-spacing-3);
  left: var(--Spacing-spacing-3);
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--Light-Scheme-Neutral-UI-neutral-ui-100, #20282e);
  pointer-events: none;
}

.media-play-badge__icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
</style>
